import { Box, CircularProgress, Container } from '@mui/material';
import React from 'react';
import { SubHeaderLocations } from '../../../LocationsLayout/SubHeaderLocations';
import useTypeEntity from '../../../useTypeEntity';
import TitleIcon from '../../../../../../../../theme/ui/Atoms/TilteIcon';

interface PanelLayoutProps {
  children: React.ReactNode;
  innerContainerMaxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  title: string;
  icon?: React.ReactNode;
  subPages?: { name: string; url: string }[];
}
function PanelLayout(props: PanelLayoutProps) {
  const {
    children,
    innerContainerMaxWidth = 'lg',
    title,
    subPages,
    icon,
  } = props;
  const { entity, type, isLoading, pathGroups, marketId } = useTypeEntity();
  return (
    <Box>
      <SubHeaderLocations
        marketId={marketId}
        entity={entity}
        type={type}
        loading={isLoading}
        pathGroups={pathGroups}
        subPages={subPages}
      />
      <Container maxWidth="xl">
        <TitleIcon icon={isLoading ? <CircularProgress size={'1em'} /> : icon}>
          {title}
        </TitleIcon>

        <Container
          maxWidth={innerContainerMaxWidth}
          sx={{
            overflow: 'auto',
          }}
        >
          {children}
        </Container>
      </Container>
    </Box>
  );
}

export default PanelLayout;
